import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiCoffee, FiRotateCcw, FiClock, FiZap } = FiIcons;

const TopBar = ({ sessionStart, onReset }) => {
  const [sessionTime, setSessionTime] = useState('00:00');

  useEffect(() => {
    const updateTimer = () => {
      const elapsed = Date.now() - sessionStart;
      const minutes = Math.floor(elapsed / 60000);
      const hours = Math.floor(minutes / 60);
      const mins = minutes % 60;
      setSessionTime(`${hours.toString().padStart(2, '0')}:${mins.toString().padStart(2, '0')}`);
    };

    updateTimer();
    const interval = setInterval(updateTimer, 1000);
    return () => clearInterval(interval);
  }, [sessionStart]);

  return (
    <header className="bg-gradient-to-r from-amber-500 via-orange-500 to-red-500 text-white shadow-2xl sticky top-0 z-50 backdrop-blur-sm">
      <div className="px-4 py-4">
        <div className="flex items-center justify-between">
          <motion.div 
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            className="flex items-center space-x-3"
          >
            <div className="w-10 h-10 bg-white/20 backdrop-blur-sm rounded-xl flex items-center justify-center shadow-lg">
              <SafeIcon icon={FiCoffee} className="text-2xl" />
            </div>
            <div>
              <h1 className="text-xl font-bold">Kopitiam Counter</h1>
              <p className="text-white/80 text-xs font-medium">Singapore Style</p>
            </div>
          </motion.div>

          <motion.div 
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            className="flex items-center space-x-3"
          >
            <div className="flex items-center space-x-2 bg-white/20 backdrop-blur-sm px-4 py-2 rounded-xl shadow-lg">
              <SafeIcon icon={FiClock} className="text-sm" />
              <span className="font-mono font-bold text-sm">{sessionTime}</span>
            </div>
            
            <motion.button
              whileTap={{ scale: 0.95 }}
              whileHover={{ scale: 1.05 }}
              onClick={onReset}
              className="flex items-center space-x-2 bg-white/20 backdrop-blur-sm hover:bg-white/30 px-4 py-2 rounded-xl text-sm font-bold transition-all duration-200 min-h-[44px] shadow-lg hover:shadow-xl"
              aria-label="Reset session"
            >
              <SafeIcon icon={FiRotateCcw} className="text-sm" />
              <span>Reset</span>
            </motion.button>
          </motion.div>
        </div>
      </div>
      
      {/* Animated gradient line */}
      <div className="h-1 bg-gradient-to-r from-white/30 via-white/60 to-white/30 relative overflow-hidden">
        <motion.div
          className="absolute inset-0 bg-gradient-to-r from-transparent via-white/80 to-transparent"
          animate={{ x: ['-100%', '100%'] }}
          transition={{ duration: 3, repeat: Infinity, ease: 'linear' }}
        />
      </div>
    </header>
  );
};

export default TopBar;